const ContactSalesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 md:px-8">
        {/* URL Bar Simulation */}
        <div className="bg-white border rounded-lg p-3 mb-8 text-sm text-gray-600">
          https://mirasso.co.jp/contact ページリンク
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-lg shadow-md p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-lg text-pink-600 font-medium mb-2">学校・法人関係者の方へ</h1>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              弊社へのお問い合わせ・資料請求は<br />
              こちらにて承ります
            </h2>
            <p className="text-sm text-gray-600">
              ご返信は3営業日までお時間をいただいております。<br />
              3営業日を過ぎても返信がない場合は、お手数ですが再度お問い合わせをお願いいたします。
            </p>
          </div>

          {/* Contact Form */}
          <form className="space-y-6">
            {/* Name Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                お名前 <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="姓　名"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent bg-gray-50"
              />
            </div>

            {/* Organization Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                法人・団体名 <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="○○高等学校"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent bg-gray-50"
              />
            </div>

            {/* Email Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                メールアドレス <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="mira@email.com"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent bg-gray-50"
              />
            </div>

            {/* Inquiry Content Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                お問い合わせ内容 <span className="text-red-500">*</span>
              </label>
              <textarea
                rows={8}
                placeholder="ご質問ください。"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent bg-gray-50 resize-none"
              />
            </div>

            {/* Privacy Policy Checkbox */}
            <div className="flex items-center">
              <input
                type="checkbox"
                id="privacy"
                className="h-4 w-4 text-pink-600 rounded border-gray-300 focus:ring-pink-500"
              />
              <label htmlFor="privacy" className="ml-2 text-sm text-gray-600">
                プライバシーポリシーに同意して送信する
              </label>
            </div>

            {/* Submit Button */}
            <div className="text-center pt-4">
              <button
                type="submit"
                className="bg-pink-500 hover:bg-pink-600 text-white font-medium py-3 px-8 rounded-md text-sm transition-colors"
              >
                この内容で送信する ›
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ContactSalesPage